const MovementsAndLocations = { ENTRY: 'entry', EXIT: 'exit', PICKUP: 'pickup', DROP: 'drop' };
const TrackDashboardItems = {
  PICKUP_COMPLIANCE: 'pickupCompliance',
  DROP_COMPLIANCE: 'dropCompliance',
  PICKUP_AT_RISK: 'pickupAtRisk',
  DROP_AT_RISK: 'dropAtRisk',
  SLA_BREACHED_PICKUP_COUNT: 'slaBreachedPickupCount',
  SLA_BREACHED_DROP_COUNT: 'slaBreachedDropCount',
  PICKUP_REACHED_ON_TIME: 'pickupReachedOnTime',
  DROP_REACHED_ON_TIME: 'dropReachedOnTime',
  PICKUP_REACHED: 'pickupReached',
  DROP_REACHED: 'dropReached',
  PICKUP_NOT_REACHED: 'pickupNotReached',
  DROP_NOT_REACHED: 'dropNotReached',
  IN_TRANSIT: 'inTransit',
  NOT_IN_TRANSIT: 'notInTransit',
  DELIVERY_ETA: 'deliveryEta',
  PICKUP_ETA: 'pickupEta',
  TRACKED: 'tracked',
  NON_TRACKABLE: 'nontrackable',
};
const LocationTracker = {
  SUCCESS: 200,
  BAD_REQUEST: 400,
  ERROR: 500,
  CREATED: 201,
  UPDATED: 202,
  NOT_FOUND: 404,
  UNAUTHORISED: 401,
  FORBIDDEN_ERROR: 403,
  INTERNAL_SERVER: 500,
  CREATED_SUCCESS_MESSAGE: ' created successfully!',
  CREATED_ERROR_MESSAGE: ' creation failed!',
  UPDATED_SUCCESS_MESSAGE: ' updated successfully!',
  UPDATED_ERROR_MESSAGE: ' update failed!',
  FETCH_SUCCESS_MESSAGE: ' found successfully!',
  FETCH_ERROR_MESSAGE: ' fetch failed!',
  FETCH_NOT_FOUND: ' data not found!',
  DELETE_SUCCESS_MESSAGE: ' deleted successfully!',
  DELETE_ERROR_MESSAGE: ' deletion failed!',
  REQUIRED_FIELD_MESSAGE: ' can not be empty!',

  // 1: APP_TRACKING, 2: SIM_TRACKING
  APP_TRACKING_MODE: 1,
  SIM_TRACKING_MODE: 2,
  GPS_TRACKING_MODE: 3,
  HYPERTRACK_MODE: 4,

  // TRIP STATE
  PENDING_TRIP: 'PENDING',
  STARTED_TRIP: 'STARTED',
  COMPLETED_TRIP: 'COMPLETED',
  CANCELLED_TRIP: 'CANCELLED',
  INVALID_TRIP: 'INVALID',
  NOT_TRACKING: 'NOT TRACKING',

  // NETWORK PROVIDERS
  AIRTEL_NETWORK: 'AIRTEL',
  VODAFONE_NETWORK: 'VODAFONE',
  DEFAULT_EXPECTED_TIME_TRIP: 86400000,

  // UNIT MEASURMENT
  DISTANCE_UNIT: 'km',
  SPEED_UNIT: 'km/hr',
  CRON_FREQUENCY: 16,
  HOURS_UNIT: 'hours',
  MINUTES_UNIT: 'minutes',

  // DEFAULT HALT DISTANCE VALUE IN METER
  HALT_DISTANCE: 500,

  // DEFAULT VALUE FOR REACHED DISTANCE IN KM
  REACHED_DISTANCE: 2,
  AUTH_TOKEN_TTL: 3540, // in seconds
  AIRTEL_VODAFONE_CACHE_KEY: 'AIRTEL_VODAFONE_CACHE_KEY',
  ONE_DAY_MS: 86400000,
  ONE_KM_IN_METRES: 1000,
  FORMAT_V1_AUTO_COMPLETE_HOURS: 120,
  SUPPORTED_TRACKING_TYPES: ['SIM', 'APP', 'GPS', 'HYPERTRACK'],
  APP_TRACKING_TYPES: ['APP', 'HYPERTRACK'],
  MovementsAndLocations,
  TrackDashboardItems,
  TripLevelDashboardItems: [TrackDashboardItems.TRACKED, TrackDashboardItems.NON_TRACKABLE],
  TWELVE_HOURS_MS: 43200000,
  TWENTY_FOUR_HOURS_MS: 86400000,
  TWO_HOURS_MS: 7200000,
};
LocationTracker.supportedTrackingTypes = LocationTracker.SUPPORTED_TRACKING_TYPES
  .reduce((acc, type) => {
    const _acc = acc;
    _acc[type] = type;
    return _acc;
  }, {});
const TripErrors = {
  CONSENT_NOT_RECEIVED: 'Consent not received',
  LOCATION_NOT_AVAILABLE: 'Location not available',
  OPERATOR_NOT_SUPPORTED: 'Operator not supported',
};

module.exports = {
  LocationTracker,
  TripErrors,
};
